import { INameId } from '@modeso/types__aumico-lib-core-be';

export class IRegistrationFormValue {
    email: string;
    country: INameId;
    acceptPolicy: boolean;
    subscribeMarketing?: boolean;
}
